<!-- 详细页:运盘 -->
<template>
  <div class="layout-detail-fortune">
    <!-- 1. 标题部分 -->
    <div v-if="showTitle" class="layout-dft-title">
        <!-- 标签图标 -->
        <span v-if="showLabel" class="layout-dft-icon-label" v-bind:class="{'layout-dft-icon-label-org':detailInfo.label != '' || detailInfo.remark != ''}" @click="clickLabel">
            <i class="iconbg icon-label" v-bind:class="{'icon-label-org':detailInfo.label != '' || detailInfo.remark != ''}"></i>标签
        </span>
        <span v-if="subTitle == ''">
            <i class="iconfont icon-arrowflower-left layout-dft-icon-f"></i>
            <span v-if="fortuneTitle" class="layout-dft-cur-title">{{fortuneTitle}}大运</span>
            <span v-else class="layout-dft-cur-title">大运</span>
            <i class="iconfont icon-arrowflower-right layout-dft-icon-f"></i>
        </span>
        <span v-else class="layout-dft-cur-title-sub">{{subTitle}}</span>
        <!-- 百科图标 -->
        <i v-if="detailInfo.toBaike" class="iconfont icon-baike layout-dft-icon-baike" @click.stop="clickBaiKe"></i>
        <!-- 切换模式图标 -->
        <i class="iconfont icon-table layout-dft-icon" @click.stop="toggleTable"></i>
    </div>

    <!-- 2. 1行5列or10列显示 -->
    <div v-if="showLines != 0" class="layout-dft-list" v-bind:class="{'layout-dft-list-mini': parentFrom == 'mini'}">
        <!-- 2.1 大运列表 -->
        <transition v-bind:name="transitioned ? 'fortune-fade' : ''">
            <div id="dayun" ref="dayun" v-if="(showTable == 5 && showType == 'dayun') || (parentFrom != 'mini' && showTable == 10 && showType == 'liunian') || (parentFrom == 'mini' && showTable == 10 && showType == 'dayun')" class="layout-dft-content column-br" v-bind:class="'column-fortune-' + showTable">
                <column-item
                    v-for="data in fortuneData"
                    v-bind:key="data.id"
                    v-bind:ColumnData="data"
                    v-bind:columnFateData="{}"
                    v-bind:clickFunc="clickItem"
                ></column-item>
            </div>
        </transition>
        <!-- 2.2 流年列表 -->
        <transition v-bind:name="transitioned ? 'fortune-fade' : ''">
            <div id="liunian" ref="liunian" v-if="(showTable == 5 && showType == 'liunian') || (parentFrom != 'mini' && showTable == 10 && ((showType == 'liunian' && liunianData.length != 0) || showType == 'liuyue')) || (parentFrom == 'mini' && showTable == 10 && showType == 'liunian')" class="layout-dft-content column-br" v-bind:class="'column-fortune-' + showTable">
                <column-item
                    v-for="data in liunianData"
                    v-bind:key="data.id"
                    v-bind:ColumnData="data"
                    v-bind:columnFateData="{}"
                    v-bind:clickFunc="clickItem"
                ></column-item>
            </div>
        </transition>
        <!-- 2.3 流月列表 -->
        <transition v-bind:name="transitioned ? 'fortune-fade' : ''">
            <div ref="liuyue" v-if="(showTable == 5 && showType == 'liuyue') || (parentFrom != 'mini' && showTable == 10 && (showType == 'liuyue' || showType == 'liuri')) || (parentFrom == 'mini' && showTable == 10 && showType == 'liuyue')" class="layout-dft-content" v-bind:class="'column-fortune-' + showTable">
                <div id="liuyue" ref="liuyuecolumn" class="column-br" v-bind:class="{'column-fortune-5 column-fortune-6': showTable == 5, 'column-fortune-10 column-fortune-12': showTable == 10}">
                    <column-item
                    v-for="data in liuyueData"
                    v-bind:key="data.time[0]"
                    v-bind:ColumnData="data"
                    v-bind:columnFateData="{}"
                    v-bind:clickFunc="clickItem"
                    ></column-item>
                </div>
            </div>
        </transition>
        <!-- 2.4 流日列表 -->
        <transition v-bind:name="transitioned ? 'fortune-fade' : ''">
            <div ref="liuri" v-if="(showTable == 5 && showType == 'liuri') || (parentFrom != 'mini' && showTable == 10 && (showType == 'liuri' || showType == 'liushi')) || (parentFrom == 'mini' && showTable == 10 && showType == 'liuri')" class="layout-dft-content" v-bind:class="'column-fortune-' + showTable">
                <div id="liuri" ref="liuricolumn" class="column-br" v-bind:class="{'column-fortune-5 column-fortune-15': showTable == 5, 'column-fortune-10 column-fortune-30': showTable == 10}">
                    <column-item
                    v-for="data in liuriData"
                    v-bind:key="data.key"
                    v-bind:ColumnData="data"
                    v-bind:columnFateData="{}"
                    v-bind:clickFunc="clickItem"
                    ></column-item>
                </div>
            </div>
        </transition>
        <!-- 2.5 流时列表 -->
        <transition v-bind:name="transitioned ? 'fortune-fade' : ''">
            <div ref="liushi" v-if="(showTable == 5 && showType == 'liushi') || (parentFrom != 'mini' && showTable == 10 && showType == 'liushi') || (parentFrom == 'mini' && showTable == 10 && showType == 'liushi')" class="layout-dft-content" v-bind:class="'column-fortune-' + showTable">
                <div id="liushi" ref="liushicolumn" class="column-br" v-bind:class="{'column-fortune-5 column-fortune-7': showTable == 5, 'column-fortune-10 column-fortune-14': showTable == 10}">
                    <column-item
                    v-for="data in liushiData"
                    v-bind:key="data.key"
                    v-bind:ColumnData="data"
                    v-bind:columnFateData="{}"
                    v-bind:clickFunc="clickItem"
                    ></column-item>
                </div>
            </div>
        </transition>
    </div>

    <!-- 3. 箭头left、箭头right -->
    <div v-if="parentFrom == 'mini'" class="layout-detail-fortune-icon-box">
        <div v-if="CONFIG.platform != 'web'" class="layout-detail-fortune-icon layout-detail-fortune-icon-arrow" @click="clickFortuneArrow">
            <span><i class="iconbg icon-fortune-arrow" v-bind:class="{'icon-fortune-arrow-down': showFortuneLines == 0}"></i></span>
        </div>
        <div v-if="fateSideData.length > 0 && showLines > 0" class="layout-detail-fortune-icon layout-detail-fortune-icon-left" @click="clickLeftArrow">
            <span><i class="iconbg icon-arrow-left" v-bind:class="{'icon-arrow-blue-left': showLeftArrow}"></i></span>
        </div>
        <div v-if="fateSideData.length > 0 && showLines > 0" class="layout-detail-fortune-icon layout-detail-fortune-icon-right" @click="clickRightArrow">
            <span><i class="iconbg icon-arrow-right" v-bind:class="{'icon-arrow-blue-right': showRightArrow}"></i></span>
        </div>
    </div>
  </div>
</template>

<script>
import ColumnItem from "../../components/ColumnItem.vue";
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
import { LOADING_DOM } from '../../modules/dom';
import { CONFIG } from '../../modules/config';
export default {
    name: "FortunePanel",
    components: { ColumnItem },
    props: [
        'fateSideData',
        'detailInfo',
        'fortuneTitle',
        'fortuneData',
        'transitioned',
        'subTitle',
        'parentFrom',
        'showType',
        'showLabel',
        'showTitle',
        'showTable',
        'showLines',
        'showFortuneLines',
        'liunianData',
        'liuyueData',
        'liuriData',
        'liushiData',
        'labelFunc',
        'toggleFunc',
        'arrowFunc',
        'itemFunc',
        'moveLeftFunc',
        'moveRightFunc',
        'scrollLeftFunc',
        'scrollRightFunc',
        'scrollBackFunc',
        'resetFunc',
        'showLeftArrow',
        'showRightArrow'
    ],
    data() {
        return {
            CONFIG: CONFIG,
            isFirstOne: false,
            isLastOne: false,
            translateXValue: 0,
            translateXLock: false,
            itemClicked: false,
            curList: null,
            curListWidth: 0,
            touchStartLock: false
        }
    },
    mounted() {
        this.$bus.on('resetFortune', this.resetFortune)
        this.$bus.on('updateFortuneDom', this.initDom)
        this.$bus.on('updateFortuneLiuNian', this.updateLiunian)
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 100);
    },
    destroyed() {
        this.$bus.off('resetFortune', this.resetFortune)
        this.$bus.off('updateFortuneDom', this.initDom)
        this.$bus.off('updateFortuneLiuNian', this.updateLiunian)
    },
    methods: {
        initDom() {
            // 动态设置大运列表的样式:增加了起运前的item
            var dayunDiv = document.getElementById('dayun'),
                curClass = dayunDiv ? dayunDiv.className : '';
            if(this.fortuneData && this.fortuneData.length > 10 && dayunDiv) {
                dayunDiv.className = curClass != '' && this.showType == 'dayun' ? curClass + ' column-fortune-12' : curClass;
            }
        },
        updateLiunian() {
            var liunianDiv = document.getElementById('liunian'),
                curClass = liunianDiv ? liunianDiv.className : '';
            if(this.liunianData && liunianDiv) {
                if(this.liunianData.length < 10) {
                    liunianDiv.className = curClass + ' column-fortune-right';
                }else {
                    curClass = curClass.replace('column-fortune-right', '')
                    liunianDiv.className = curClass;
                }
            }
        },
        // 点击label标签
        clickLabel() {
            if(this.labelFunc && typeof(this.labelFunc) == 'function') {
                this.labelFunc();
            }
        },
        // 切换视图
        toggleTable() {
            if(typeof(this.toggleFunc) == 'function') {
                this.toggleFunc();
            }
        },
        // 跳转到百科
        clickBaiKe() {
            LOADING_DOM.showLoading();
            var me = this,
                baikeId = this.detailInfo.toBaike,
                curpath = this.$router.history.current.path;
            curpath = curpath.slice(1);
            curpath = curpath.replace(/\//g, '_');

            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: true,
                baikeId: baikeId,
                baikeType: 'hot',
                sucCb: function() {
                    if(CONFIG.platform == 'web') {
                        me.$router.replace('/famouspediareadweb/' + baikeId+'/'+curpath)
                    }else {
                        me.$router.replace('/famouspediaread/' + baikeId+'/'+curpath)
                    }
                    LOADING_DOM.hideLoading();
                },
                failCb: function() {
                    me.$toast('没有找到这个八字的百科数据');
                    LOADING_DOM.hideLoading();
                }
            })
        },
        // 点击箭头
        clickFortuneArrow() {
            this.resetFortune();
            if(typeof(this.arrowFunc) == 'function') {
                this.arrowFunc();
            }
        },
        clickItem(data) {
            var me = this;
            this.itemClicked = true;
            this.resetFortune();
            if(typeof(this.itemFunc) == 'function') {
                this.itemFunc(data);
            }
        },
        animateCurList(fromX, toX, width, animateCb, retStyle = false) {
            var me = this, toLeft = fromX > toX,
                distX = Math.abs(fromX - toX), time = 2000 / distX;
            // console.log('animateCurList-----', fromX, toX, toLeft);
            var animate = function() {
                setTimeout(() => {
                    if(toLeft) {
                        fromX = fromX > toX ? fromX - 10 : toX; // 滚到左边
                    }else {
                        fromX = fromX < toX ? fromX + 10 : toX; // 滚到右边
                    }
                    me.curList.style = 'width: ' + width + 'px; transition-duration: 0ms; transform: translateX(' + fromX + 'px)';
                    if(fromX == toX) {
                        clearTimeout(animate)
                        if(animateCb && typeof(animateCb) == 'function') {
                            animateCb();
                        }
                        setTimeout(() => {
                            if(retStyle) {
                                me.curList.style = '';
                            }else {
                                me.curList.style = 'transition-duration: 0ms; transform: translateX(' + fromX + 'px)';
                            }
                        }, 20);
                    }else {
                        animate();
                    }
                }, time);
            };
            animate();
        },
        initCurList() {
            switch(this.showType) {
                case 'dayun':
                    this.curList = this.$refs.dayun; this.curList.style.width = '';
                    break;
                case 'liunian':
                    this.curList = this.$refs.liunian; this.curList.style.width = '';
                    this.translateXLock = false;
                    break;
                case 'liuyue':
                    this.curList = this.$refs.liuyuecolumn; this.curList.style.width = '';
                    break;
                case 'liuri':
                    this.curList = this.$refs.liuricolumn; this.curList.style.width = '';
                    break;
                case 'liushi':
                    this.curList = this.$refs.liushicolumn; this.curList.style.width = '';
                    break;
                default:
                    break;
            }
            this.curListWidth = this.curList.clientWidth;
            // 当前的滚动值
            var transform = this.curList.style.transform;
                transform = transform.replace('translateX(', '');
                transform = transform.replace('px)', '');
            var transX = isNaN(parseInt(transform)) ? 0 : parseInt(transform);
            this.translateXValue = transX;
        },
        clickLeftArrow() {
            if(!this.showLeftArrow || this.touchStartLock) { return; }
            var me = this;
            this.initCurList();
            this.touchStartLock = true;
            setTimeout(() => {
                me.touchStartLock = false;                
            }, 500);
            if(this.moveLeftFunc && typeof(this.moveLeftFunc) == 'function') {
                this.moveLeftFunc({
                    firstCb: function() {
                        me.animateCurList(me.translateXValue, innerWidth, me.curListWidth, function() {
                            if(me.scrollLeftFunc && typeof(me.scrollLeftFunc) == 'function') {
                                me.scrollLeftFunc();
                            }
                            setTimeout(() => {
                                me.curList.scrollTo(0, 0);
                            }, 20);
                        }, true);
                    },
                    cb: function() {}
                });
            }
        },
        clickRightArrow() {
            if(!this.showRightArrow || this.touchStartLock) { return; }
            var me = this;
            this.initCurList();
            this.touchStartLock = true;
            setTimeout(() => {
                me.touchStartLock = false;                
            }, 500);
            if(this.moveRightFunc && typeof(this.moveRightFunc) == 'function') {
                this.moveRightFunc({
                    firstCb: function() {
                        me.animateCurList(me.translateXValue, -innerWidth, me.curListWidth, function() {
                            if(me.scrollRightFunc && typeof(me.scrollRightFunc) == 'function') {
                                me.scrollRightFunc();
                            }
                        }, true);
                    },
                    cb: function() {}
                });
            }
        },
        resetFortune() {
            this.translateXLock = false;
            this.translateXValue = 0;
        }
    }
};
</script>